import type { Company } from 'common/api/api-types';

export * from './apiUtils';
export * from './authenticatorUtils';
export * from './errorUtils';
export * from './timeUtils';
export * from './validationUtils';

export const noop = () => {};

export const isCompanySelfDeliveryOrSaas = (company: Company | undefined) =>
  company && ['self-delivery', 'saas'].includes(company.partnership);
